<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <div>
          <span>لیست کالاها</span>
          <q-badge  rounded color="red" align="top">
            {{  items.length }} قلم
          </q-badge>

        </div>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup v-if="isDialog"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-form
          @submit="onSubmit"
          @reset="onReset" :class="!$q.screen.lt.md?'q-pa-lg':''">
        <q-card-actions align="center" v-if="items && items.length>0 && isDone===0"
                        :class="!$q.screen.lt.md?'no-padding':'q-mt-lg'">
          <q-btn label="تایید"
                 type="submit"
                 icon="search"
                 v-if="!viewOnly || (viewOnly && $store.state.roles.some(v=>['admin','can_accept_transfer_request'].includes(v)))"
                 color="primary">
            <q-badge floating color="red" text-color="white"
                     :label="!viewOnly?lodash.sumBy(items, item=> parseInt(item.selectedCount)):lodash.sumBy(items, item=> parseInt(item.acceptedCount))"/>
          </q-btn>
          <q-btn label="انصراف" type="reset" v-close-popup icon="search_off" color="red" flat class="q-ml-sm"/>
        </q-card-actions>
        <q-card-section class="no-padding">
          <q-card-section v-for="(item, index) in items" :key="index" class="no-padding">
            <q-banner :inline-actions="!$q.screen.lt.md" dense>
              <div>
                <q-btn color="indigo-10" text-color="white" disable :label="index+1" round dense/>
                <q-btn color="indigo-10"
                       class="q-ml-xs"
                       flat
                       padding="none"
                       size="lg"
                       icon="privacy_tip"
                       @click="showCartexDialog(item)"
                       round>
                  <q-tooltip>
                    کارتکس کالا
                  </q-tooltip>
                </q-btn>
                <q-chip clickable @click="showProductDetails(item)" square color="red" text-color="white"
                        :label="item.Goods_Code"/>
                {{ item.Goods_Name }}
                <q-chip text-color="white" square v-if="isDone===1" color="purple" :label="item.acceptedCount"
                        class="q-ml-xs">
                  {{ item.Unit_Name }}
                </q-chip>
                <q-chip square label="موجودی" v-if="isDone!==1 && item.SourceStore">
                  <q-badge color="green" text-color="white" :label="item[`GStor${item.SourceStore}`]"/>
                </q-chip>
              </div>
              <template v-slot:action>
                <q-input v-if="!isDone && !viewOnly"
                         v-model="item.selectedCount" dir="ltr" filled type="number"
                         :disable="parseInt(item.selectedCount)>parseInt(item[`GStor${item.SourceStore}`])"
                         @change="controlData(item)"/>
                <q-input
                    v-if="viewOnly && !isDone && $store.state.roles.some(v=>['admin','can_accept_transfer'].includes(v))"
                    v-model="item.acceptedCount" label-color="red-10"
                    :label="item.selectedCount.toString()"
                    dir="ltr" filled
                    :disable="isDone===1 || item.selectedCount>parseInt(item[`GStor${item.SourceStore}`])"
                    type="number" @change="controlDataAccept(item)"/>
                <q-btn color="red" class="q-ml-xs" flat icon="delete" round dense v-if="!isDone"
                       @click="deleteItem(item)"/>
              </template>
            </q-banner>
            <q-separator/>
          </q-card-section>
        </q-card-section>
      </q-form>
    </q-card-section>

    <q-dialog maximized v-model="showCartex">
      <GoodsCartex :goods-info="selectedProductDetails"/>
    </q-dialog>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetailsDialog">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import GoodsCartex from "@/components/store/GoodsCartex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "GoodsTransferItems",
  components: {ProductDetail, GoodsCartex},
  props: {
    transferID: {
      type: String
    },
    items: {
      type: Array,
      default: ()=> []
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    isDone: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showCartex: false,
      selectedProductDetails: '',
      showProductDetailsDialog: false
    }
  },
  methods: {
    showCartexDialog(row) {
      this.selectedProductDetails = row
      this.showCartex = true;
    },
    showProductDetails(row) {
      this.selectedProductDetails = row
      this.showProductDetailsDialog = true;
    },
    onSubmit() {
      if (!this.viewOnly) {
        this.items.forEach((record) => {
          record.ReserveGoodsInStore = ''
        })
        this.$emit('add_transfer-request', {
          items: this.items,
          transferId: this.transferID === undefined ? '' : this.transferID
        })
      } else if (this.viewOnly) {
        this.$emit('accept-transfer-request', this.items)
      }
    },
    onReset() {
      this.$emit('clear-items')
    },
    deleteItem(item) {
      this.$emit('delete-item', item)
    },
    controlData(item) {
      if (!item.selectedGood) {
        this.$emit('delete-item', item)
      }
    },
    controlDataAccept(item) {
      if (!item.acceptedCount) {
        this.$emit('delete-item', item)
      } else if (item.acceptedCount > parseInt(item[`GStor${item.SourceStore}`])) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'تعداد وارد شده بیشتر از موجودی است'
        })
        item.acceptedCount = 0
      }
    }
  }
}
</script>

<style scoped>

</style>